async function updateCartProgress() {
  const progress = document.querySelector('[data-cart-progress]');

  if (!progress) return;

  const threshold = Number(progress.dataset.threshold);

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const total = cart.total_price / 100;

    let percent = (total / threshold) * 100;

    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    const remaining = threshold - total;

    const fill = progress.querySelector('.cart-progress__fill');
    const message = progress.querySelector('.cart-progress__message');

    fill.style.width = `${percent}%`;

    if (remaining > 0) {
      message.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/1001/6564/8676/files/download.svg?v=1779195746" 
        style="width:16px;height:16px;margin-right:6px;vertical-align:middle;">
        You are ₹${remaining.toFixed(2)} away from free shipping`;
    } else {
      message.textContent =
        `🎉 You unlocked free shipping!`;
    }
  } catch (error) {
    console.error('Cart Progress Error:', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateCartProgress();
});

document.addEventListener('cart:updated', () => {
  updateCartProgress();
});

/* Backup polling for themes that don't emit events */
setInterval(updateCartProgress, 2000);